import styled from "styled-components"

export const OverviewContainer = styled.div`
  margin-bottom: 45px;
  width: 650px;
  @media (max-width: 767px) {
    width: 100%;
  }
`
export const CuricullamContainer = styled.div`
  margin-bottom: 40px;
`

export const CurriculumListContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 5px;
  width: 650px;
  @media (max-width: 767px) {
    width: 100%;
  }
`
export const List = styled.li`
  width: 650px;
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
  p{
    font-family: "Roboto Slab";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0.03em;
    color: #555555;
    position: relative;
    padding-left: 0px;
    max-width: 460px;
    @media (max-width: 767px) {
      width: 100%;
    }
  }
  @media(max-width:767px){
    width: 100%;
  }
}
`
export const Title = styled.h2`
  font-family: "Roboto Slab";
  font-style: normal;
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 46px;
  color: #000000;
  margin-bottom: 25px;
  @media (max-width: 767px) {
    font-size: 30px;
    line-height: 40px;
  }
`

export const TypographyDescription = styled.p`
  font-family: "Roboto Slab";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.03em;
  color: #555555;
  max-width: 1043px;
  width: 100%;
`
export const InfoCard = styled.ul`
  width: 156px;
  height: 60px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  margin-right: 20px;
`

export const ImgCover = styled.span`
  margin-right: 10px;
  display: flex;
  align-items: flex-start;
  margin-top: 5px;
`

export const ButtonSection = styled.div`
  width: 100%;
  max-width: 340px;

  button {
    background: #007bff;
    color: white;
    padding: 12px 24px;
    font-size: 22px;
    font-weight: 600;
    width: 100%;
    margin-bottom: 20px;
  }
`